import {
  FETCH_ALL_VEHICLES,
  FETCH_ALL_VEHICLES_SUCCESS,
  FETCH_ALL_VEHICLES_FAILED,
  EDIT_VEHICLE_SUCCESS,
  EDIT_VEHICLE,
  EDIT_VEHICLE_FAILED
} from "../store/types";

export const INITIAL_STATE = {
  vehicles: null,
  loading: false,
  error: {
    flag: false,
    msg: null
  }
}

export const vehiclesreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_ALL_VEHICLES:
      return {
        ...state,
        loading: false
      };
    case FETCH_ALL_VEHICLES_SUCCESS:
      return {
        ...state,
        vehicles: action.payload,
        loading: false
      };
    case EDIT_VEHICLE_FAILED:
      return {
        ...state,
        loading: false
      };
    case EDIT_VEHICLE_SUCCESS:
      return {
        ...state,
        loading: false
      };
    case EDIT_VEHICLE:
      return {
        ...state,
        loading: true
      };
    case FETCH_ALL_VEHICLES_FAILED:
      return {
        ...state,
        vehicles: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    default:
      return state;
  }
};